import styled, { css } from 'styled-components';
import { FlexContainer } from '@taxdown/piccolo-web';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';
import { pxToRem } from 'Styles/utils/utils';

export const CardContainer = styled(FlexContainer)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 100%;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    flex-direction: column;
  }
`;

export const Card = styled(FlexContainer)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid transparent;
  border-radius: ${pxToRem(16)};
  background: ${({ theme: { colors } }) => colors.grey_1};
  width: ${pxToRem(288)};
  height: ${pxToRem(288)};
  margin: ${pxToRem(10)};
  padding: ${pxToRem(27)};
  cursor: pointer;
  &:hover {
    background: ${({ theme: { colors } }) => colors.green_6};
  }
  ${({ isActive, theme: { colors } }) =>
    isActive &&
    css`
      background: ${colors.green_6};
    `};
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    flex-direction: column;
    margin-top: ${pxToRem(10)};
    min-height: ${pxToRem(300)};
  }
`;

export const TextContainer = styled(FlexContainer)`
  display: flex;
  flex-direction: column;
  height: ${pxToRem(66)};
`;
